import { loader } from "@monaco-editor/react";

// Serve Monaco from this origin instead of the jsDelivr CDN so editors work on
// networks without internet access (e.g. a competition LAN). The files are
// copied from the monaco-editor package into public/vs by
// scripts/copy-vendor-assets.mjs, which runs before `dev` and `build`.
loader.config({
    paths: {
        vs: "/vs",
        // @ts-expect-error incomplete upstream type
        "vs/editor/editor.main.nls": "/editor.main.nls.js",
    },
});
